import type { MatchDetails } from "./types";

// ==================================================
// MATCH DETAILS 2026/27 — MEN'S DOMESTIC
// GALLAGHER PREMIERSHIP
// ==================================================

export const matchDetailsPremMen: MatchDetails[] = [

  // ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 1
  // ==================================================

  {
    matchKey: "northampton-saints-vs-newcastle-red-bulls",
    highlightsUrl: "https://www.youtube.com/watch?v=WJDcl1C4GGk",
    timeline: [
      {
        minute: "0'",
        label: "Kick-off — Franklin's Gardens, Northampton",
      },
      {
        minute: "40'",
        label: "Half Time",
      },
      {
        minute: "80'",
        label: "Full Time",
      },
    ],
    lineups: {
      homeStarting: [
        { number: 15, name: "James Pater" },
        { number: 14, name: "Tommy Freeman" },
        { number: 13, name: "Rory Hutchinson" },
        { number: 12, name: "Fraser Dingwall (C)" },
        { number: 11, name: "George Hendy" },
        { number: 10, name: "Fin Smith" },
        { number: 9, name: "Tom McParland" },
        { number: 1, name: "Emmanuel Iyogun" },
        { number: 2, name: "Curtis Langdon" },
        { number: 3, name: "Elliot Millar Mills" },
        { number: 4, name: "Alex Coles" },
        { number: 5, name: "Ed Prowse" },
        { number: 6, name: "Josh Kemeny" },
        { number: 7, name: "Henry Pollock" },
        { number: 8, name: "Callum Chick" },
      ],
      homeBench: [
        { number: 16, name: "Robbie Smith" },
        { number: 17, name: "Dan Fischetti" },
        { number: 18, name: "Ion Neculai" },
        { number: 19, name: "Tom Lockett" },
        { number: 20, name: "Josh Taylor" },
        { number: 21, name: "Archie Mitchell" },
        { number: 22, name: "Anthony Belleau" },
        { number: 23, name: "Ollie Sleightholme" },
      ],
      awayStarting: [
        { number: 15, name: "Hosea Obatoyinbo" },
        { number: 14, name: "Christian Wade" },
        { number: 13, name: "George Hearle" },
        { number: 12, name: "Chris Harris" },
        { number: 11, name: "Werner Kok" },
        { number: 10, name: "Brett Connon" },
        { number: 9, name: "Sam Elliott" },
        { number: 1, name: "Pouri Rakete-Stones" },
        { number: 2, name: "George McGuigan" },
        { number: 3, name: "Elliot Millar Mills" },
        { number: 4, name: "Tim Usher" },
        { number: 5, name: "Cam Jordan" },
        { number: 6, name: "Max Hicks" },
        { number: 7, name: "Callum Christie (C)" },
        { number: 8, name: "Sam Graham" },
      ],
      awayBench: [
        { number: 16, name: "Fletcher" },
        { number: 17, name: "West" },
        { number: 18, name: "Harper" },
        { number: 19, name: "Molina" },
        { number: 20, name: "Leatherbarrow" },
        { number: 21, name: "Benitez Cruz" },
        { number: 22, name: "Zack Henry" },
        { number: 23, name: "Sotutu" },
      ],
    },
    performances: [
      {
        category: "Coach",
        player: "Phil Dowson",
        value: "Northampton Saints",
      },
      {
        category: "Captain",
        player: "Fraser Dingwall",
        value: "Northampton Saints",
      },
      {
        category: "Captain",
        player: "Callum Christie",
        value: "Newcastle Red Bulls",
      },
      {
        category: "Venue",
        player: "Franklin's Gardens",
        value: "Northampton",
      },
      {
        category: "Referee",
        player: "Anthony Woodthorpe",
        value: "RFU",
      },
      {
        category: "Assistant Referee 1",
        player: "George Selwood",
        value: "RFU",
      },
      {
        category: "Assistant Referee 2",
        player: "Veryan Boscawen",
        value: "RFU",
      },
      {
        category: "TMO",
        player: "Ian Tempest",
        value: "RFU",
      },
      {
        category: "Try Scorers",
        player:
          "Tommy Freeman (3), James Pater (3), George Hendy, Alex Coles, Ollie Sleightholme",
        value: "Northampton Saints",
      },
      {
        category: "Try Scorers",
        player: "Christian Wade (2), Cam Jordan, Werner Kok",
        value: "Newcastle Red Bulls",
      },
      {
        category: "Milestone",
        player: "Henry Pollock",
        value: "50th appearance for Northampton",
      },
    ],
  },

  {
    matchKey: "harlequins-vs-bath",
    highlightsUrl: "https://www.youtube.com/watch?v=O54NNnFGLWs",
    timeline: [
      {
        minute: "0'",
        label: "Kick-off — Twickenham Stoop, London",
      },
      {
        minute: "12'",
        label: "TRY: Bath - Dan du Preez",
      },
      {
        minute: "14'",
        label: "CON: Bath - Finn Russell",
      },
      {
        minute: "16'",
        label: "TRY: Harlequins - Will Porter",
      },
      {
        minute: "20'",
        label: "TRY: Bath - Joe Cokanasiga",
      },
      {
        minute: "21'",
        label: "CON: Bath - Finn Russell",
      },
      {
        minute: "28'",
        label: "TRY: Harlequins - Chandler Cunningham-South",
      },
      {
        minute: "32'",
        label: "TRY: Bath - Santiago Carreras",
      },
      {
        minute: "33'",
        label: "CON: Bath - Finn Russell",
      },
      {
        minute: "40+2'",
        label: "TRY: Bath - Dan Frost",
      },
      {
        minute: "40+3'",
        label: "CON: Bath - Finn Russell",
      },
      {
        minute: "40'",
        label: "Half Time — Harlequins 10-28 Bath",
      },
      {
        minute: "45'",
        label: "TRY: Harlequins - Pedro Delgado",
      },
      {
        minute: "46'",
        label: "CON: Harlequins - Connor Slevin",
      },
      {
        minute: "53'",
        label: "YELLOW CARD: Harlequins - Sam Riley",
      },
      {
        minute: "71'",
        label: "TRY: Bath - Ewan Richards",
      },
      {
        minute: "80'",
        label: "Full Time — Harlequins 17-33 Bath",
      },
    ],
    lineups: {
      homeStarting: [
        { number: 15, name: "Tyrone Green" },
        { number: 14, name: "Nick Anderson" },
        { number: 13, name: "Oscar Beard" },
        { number: 12, name: "Lennox Bradley" },
        { number: 11, name: "Cadan Murley (C)" },
        { number: 10, name: "Connor Slevin" },
        { number: 9, name: "Will Porter" },
        { number: 1, name: "Archie Hobson" },
        { number: 2, name: "Jack Walker" },
        { number: 3, name: "Pedro Delgado" },
        { number: 4, name: "Joe Dun" },
        { number: 5, name: "Tom Browne" },
        { number: 6, name: "Jack Kenningham" },
        { number: 7, name: "Will Evans" },
        { number: 8, name: "Chandler Cunningham-South" },
      ],
      homeBench: [
        { number: 16, name: "Sam Riley" },
        { number: 17, name: "Boris Wenger" },
        { number: 18, name: "Harry Johnson-Holmes" },
        { number: 19, name: "Kieran Treadwell" },
        { number: 20, name: "Guido Petti" },
        { number: 21, name: "Friday" },
        { number: 22, name: "Josh Bellamy" },
        { number: 23, name: "Rodrigo Isgró" },
      ],
      awayStarting: [
        { number: 15, name: "Santiago Carreras" },
        { number: 14, name: "Joe Cokanasiga" },
        { number: 13, name: "Ollie Lawrence" },
        { number: 12, name: "Max Ojomoh" },
        { number: 11, name: "Tom De Glanville" },
        { number: 10, name: "Finn Russell" },
        { number: 9, name: "Tom Carr-Smith" },
        { number: 1, name: "Beno Obano" },
        { number: 2, name: "Dan Frost" },
        { number: 3, name: "Will Stuart" },
        { number: 4, name: "Ted Hill" },
        { number: 5, name: "Charlie Ewels (C)" },
        { number: 6, name: "Josh Bayliss" },
        { number: 7, name: "Sam Underhill" },
        { number: 8, name: "Dan du Preez" },
      ],
      awayBench: [
        { number: 16, name: "Tuipulotu" },
        { number: 17, name: "Kirk" },
        { number: 18, name: "Griffin" },
        { number: 19, name: "Richards" },
        { number: 20, name: "Pepper" },
        { number: 21, name: "Van der Linde" },
        { number: 22, name: "Redpath" },
        { number: 23, name: "Reid" },
      ],
    },
    performances: [
      {
        category: "Coach",
        player: "Jason Gilmore",
        value: "Harlequins",
      },
      {
        category: "Coach",
        player: "Johann van Graan",
        value: "Bath",
      },
      {
        category: "Captain",
        player: "Cadan Murley",
        value: "Harlequins",
      },
      {
        category: "Captain",
        player: "Charlie Ewels",
        value: "Bath",
      },
      {
        category: "Venue",
        player: "Twickenham Stoop",
        value: "London",
      },
      {
        category: "Referee",
        player: "Karl Dickson",
        value: "RFU",
      },
      {
        category: "Assistant Referee 1",
        player: "Richard Gordon",
        value: "RFU",
      },
      {
        category: "Assistant Referee 2",
        player: "Simon Harding",
        value: "RFU",
      },
      {
        category: "TMO",
        player: "David Rose",
        value: "RFU",
      },
      {
        category: "Try Scorers",
        player:
          "Dan du Preez, Joe Cokanasiga, Santiago Carreras, Dan Frost, Ewan Richards",
        value: "Bath",
      },
      {
        category: "Try Scorers",
        player:
          "Will Porter, Chandler Cunningham-South, Pedro Delgado",
        value: "Harlequins",
      },
      {
        category: "Milestone",
        player: "Santiago Carreras",
        value: "Try of the season contender (intercept)",
      },
    ],
  },

  // ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 1 (SAT/SUN)
  // ==================================================

  {
    matchKey: "exeter-chiefs-vs-gloucester",
    highlightsUrl: "https://www.youtube.com/watch?v=1GxZyBZHS1M",
    timeline: [
      {
        minute: "0'",
        label: "Kick-off — Sandy Park, Exeter",
      },
      {
        minute: "40'",
        label: "Half Time",
      },
      {
        minute: "80'",
        label: "Full Time",
      },
    ],
    lineups: {
      homeStarting: [],
      homeBench: [],
      awayStarting: [
        { number: 15, name: "Ben Redshaw" },
        { number: 14, name: "Will Joseph" },
        { number: 13, name: "Phil Cokanasiga" },
        { number: 12, name: "Seb Atkinson" },
        { number: 11, name: "Ben Loader" },
        { number: 10, name: "Charlie Atkinson" },
        { number: 9, name: "Caolan Englefield" },
        { number: 1, name: "Val Rapava-Ruskin" },
        { number: 2, name: "Dewi Lake (C)" },
        { number: 3, name: "Afo Fasogbon" },
        { number: 4, name: "Jean Kleyn" },
        { number: 5, name: "Arthur Clark" },
        { number: 6, name: "Freddie Thomas" },
        { number: 7, name: "Jac Morgan" },
        { number: 8, name: "Will Trenholm" },
      ],
      awayBench: [
        { number: 16, name: "Jack Innard" },
        { number: 17, name: "Dian Bleuler" },
        { number: 18, name: "Ciaran Knight" },
        { number: 19, name: "Jack Clement" },
        { number: 20, name: "Lewis Ludlow" },
        { number: 21, name: "Dan Robson" },
        { number: 22, name: "Junior Denny" },
        { number: 23, name: "George Barton" },
      ],
    },
    performances: [
      {
        category: "Captain",
        player: "Dewi Lake",
        value: "Gloucester",
      },
      {
        category: "Captain",
        player: "TBD",
        value: "Exeter Chiefs",
      },
      {
        category: "Venue",
        player: "Sandy Park",
        value: "Exeter",
      },
      {
        category: "Note",
        player: "Dewi Lake, Jean Kleyn, Jac Morgan",
        value: "Gloucester debuts",
      },
    ],
  },

  {
    matchKey: "sale-sharks-vs-bristol-bears",
    highlightsUrl: "https://www.youtube.com/watch?v=k14sxXEHf9s",
    timeline: [
      {
        minute: "0'",
        label: "Kick-off — CorpAcq Stadium, Salford",
      },
      {
        minute: "40'",
        label: "Half Time",
      },
      {
        minute: "80'",
        label: "Full Time",
      },
    ],
    lineups: {
      homeStarting: [],
      homeBench: [],
      awayStarting: [],
      awayBench: [],
    },
    performances: [
      {
        category: "Venue",
        player: "CorpAcq Stadium",
        value: "Salford",
      },
    ],
  },

  {
    matchKey: "leicester-tigers-vs-saracens",
    highlightsUrl: "https://www.youtube.com/watch?v=OeWTSrwDwd8",
    timeline: [
      {
        minute: "0'",
        label: "Kick-off — Mattioli Woods Welford Road, Leicester",
      },
      {
        minute: "40'",
        label: "Half Time",
      },
      {
        minute: "80'",
        label: "Full Time",
      },
    ],
    lineups: {
      homeStarting: [
        { number: 15, name: "Freddie Steward" },
        { number: 14, name: "Adam Radwan" },
        { number: 13, name: "Solomone Kata" },
        { number: 12, name: "Joseph Woodward" },
        { number: 11, name: "Gabriel Hamer-Webb" },
        { number: 10, name: "Billy Searle" },
        { number: 9, name: "Jack van Poortvliet (C)" },
        { number: 1, name: "Mako Vunipola" },
        { number: 2, name: "Samiuela Moli" },
        { number: 3, name: "Joe Heyes" },
        { number: 4, name: "Finn Carnduff" },
        { number: 5, name: "Cameron Henderson" },
        { number: 6, name: "Aaron Wainwright" },
        { number: 7, name: "Tommy Reffell" },
        { number: 8, name: "Olly Cracknell" },
      ],
      homeBench: [
        { number: 16, name: "Corbin Thunder" },
        { number: 17, name: "TBD" },
        { number: 18, name: "TBD" },
        { number: 19, name: "TBD" },
        { number: 20, name: "Joaquin Moro" },
        { number: 21, name: "TBD" },
        { number: 22, name: "TBD" },
        { number: 23, name: "TBD" },
      ],
      awayStarting: [],
      awayBench: [],
    },
    performances: [
      {
        category: "Captain",
        player: "Jack van Poortvliet",
        value: "Leicester Tigers",
      },
      {
        category: "Captain",
        player: "TBD",
        value: "Saracens",
      },
      {
        category: "Venue",
        player: "Mattioli Woods Welford Road",
        value: "Leicester",
      },
      {
        category: "Note",
        player: "Aaron Wainwright",
        value: "Leicester Tigers debut",
      },
      {
        category: "Note",
        player: "Mako Vunipola",
        value: "Faces former club Saracens",
      },
    ],
  },

 // ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 2 (SAT/SUN)
  // ==================================================

{
  matchKey: "bath-vs-exeter-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Recreation Ground, Bath" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Bath 40–34 Exeter Chiefs" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=BkR4p_Hqp78",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Result", player: "Bath 40–34 Exeter Chiefs", value: "Bath bonus-point win; Exeter 2 bonus points" },
    { category: "Coach", player: "TBD", value: "Bath" },
    { category: "Coach", player: "TBD", value: "Exeter Chiefs" },
    { category: "Captain", player: "TBD", value: "Bath" },
    { category: "Captain", player: "TBD", value: "Exeter Chiefs" },
    { category: "Venue", player: "Recreation Ground", value: "Bath" },
    { category: "Note", player: "Bath tries: Redpath, van der Linde, du Preez, Russell, Penalty try, Hill", value: "Key scorers" },
  ],
},

{
  matchKey: "bristol-vs-northampton-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Ashton Gate, Bristol" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Bristol Bears 41–26 Northampton Saints" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=iWZVJnIe2I0",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Result", player: "Bristol Bears 41–26 Northampton Saints", value: "Both teams bonus points" },
    { category: "Coach", player: "TBD", value: "Bristol Bears" },
    { category: "Coach", player: "TBD", value: "Northampton Saints" },
    { category: "Captain", player: "TBD", value: "Bristol Bears" },
    { category: "Captain", player: "TBD", value: "Northampton Saints" },
    { category: "Venue", player: "Ashton Gate", value: "Bristol" },
    { category: "Note", player: "Bristol tries: Oghre, Rees-Zammit (2), Jordan, Randall, Penalty try", value: "Key scorers" },
  ],
},

{
  matchKey: "gloucester-vs-harlequins-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Kingsholm, Gloucester" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Gloucester 48–0 Harlequins" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=ZfVJt2D6TzU",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Result", player: "Gloucester 48–0 Harlequins", value: "Bonus-point win – dominant shutout" },
    { category: "Coach", player: "TBD", value: "Gloucester" },
    { category: "Coach", player: "TBD", value: "Harlequins" },
    { category: "Captain", player: "TBD", value: "Gloucester" },
    { category: "Captain", player: "TBD", value: "Harlequins" },
    { category: "Venue", player: "Kingsholm", value: "Gloucester" },
    { category: "Note", player: "Gloucester scored 8 tries", value: "Complete performance" },
  ],
},

{
  matchKey: "newcastle-vs-leicester-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Kingston Park, Newcastle" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Newcastle 19–24 Leicester Tigers" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=XIyXu4alW1E",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Result", player: "Newcastle 19–24 Leicester Tigers", value: "Leicester bonus-point win" },
    { category: "Coach", player: "TBD", value: "Newcastle" },
    { category: "Coach", player: "TBD", value: "Leicester Tigers" },
    { category: "Captain", player: "TBD", value: "Newcastle" },
    { category: "Captain", player: "TBD", value: "Leicester Tigers" },
    { category: "Venue", player: "Kingston Park", value: "Newcastle" },
  ],
},

{
  matchKey: "saracens-vs-sale-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — StoneX Stadium, London" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time — Saracens 17–21 Sale Sharks" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=jwtnadfCKR4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Result", player: "Saracens 17–21 Sale Sharks", value: "Sale first win of the season" },
    { category: "Coach", player: "TBD", value: "Saracens" },
    { category: "Coach", player: "TBD", value: "Sale Sharks" },
    { category: "Captain", player: "TBD", value: "Saracens" },
    { category: "Captain", player: "TBD", value: "Sale Sharks" },
    { category: "Venue", player: "StoneX Stadium", value: "London" },
    { category: "Note", player: "Sale tries: Jibulu, O'Flaherty, Bamber", value: "Key scorers" },
  ],
},

// ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 3
// ==================================================

{
  matchKey: "leicester-vs-gloucester-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Mattioli Woods Welford Road, Leicester" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=gn3q6d2f6lk",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Leicester Tigers" },
    { category: "Coach", player: "TBD", value: "Gloucester" },
    { category: "Captain", player: "TBD", value: "Leicester Tigers" },
    { category: "Captain", player: "TBD", value: "Gloucester" },
    { category: "Venue", player: "Mattioli Woods Welford Road", value: "Leicester" },
  ],
},

{
  matchKey: "northampton-vs-bath-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Franklin’s Gardens, Northampton" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=r-lJWD4BcT4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Northampton Saints" },
    { category: "Coach", player: "TBD", value: "Bath" },
    { category: "Captain", player: "TBD", value: "Northampton Saints" },
    { category: "Captain", player: "TBD", value: "Bath" },
    { category: "Venue", player: "Franklin’s Gardens", value: "Northampton" },
  ],
},

{
  matchKey: "saracens-vs-bristol-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — StoneX Stadium, London" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=PPXrdB0z3kU",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Saracens" },
    { category: "Coach", player: "TBD", value: "Bristol Bears" },
    { category: "Captain", player: "TBD", value: "Saracens" },
    { category: "Captain", player: "TBD", value: "Bristol Bears" },
    { category: "Venue", player: "StoneX Stadium", value: "London" },
  ],
},

{
  matchKey: "sale-vs-harlequins-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — CorpAcq Stadium, Salford" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=063vlozdlDQ",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Sale Sharks" },
    { category: "Coach", player: "TBD", value: "Harlequins" },
    { category: "Captain", player: "TBD", value: "Sale Sharks" },
    { category: "Captain", player: "TBD", value: "Harlequins" },
    { category: "Venue", player: "CorpAcq Stadium", value: "Salford" },
  ],
},

{
  matchKey: "exeter-vs-newcastle-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Sandy Park, Exeter" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=4bPKRD-Zxlw",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Exeter Chiefs" },
    { category: "Coach", player: "TBD", value: "Newcastle" },
    { category: "Captain", player: "TBD", value: "Exeter Chiefs" },
    { category: "Captain", player: "TBD", value: "Newcastle" },
    { category: "Venue", player: "Sandy Park", value: "Exeter" },
  ],
},

// ==================================================
  // GALLAGHER PREM 2026/27 — ROUND 4
// ==================================================

{
  matchKey: "gloucester-vs-bath-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Kingsholm, Gloucester" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=FVO6gR1cjoE",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Gloucester" },
    { category: "Coach", player: "TBD", value: "Bath" },
    { category: "Venue", player: "Kingsholm", value: "Gloucester" },
    { category: "Note", player: "West Country Derby", value: "Gloucester vs Bath" },
  ],
},

{
  matchKey: "newcastle-vs-sale-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Kingston Park, Newcastle" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=xPkI44DUdlk",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Newcastle Red Bulls" },
    { category: "Coach", player: "TBD", value: "Sale Sharks" },
    { category: "Venue", player: "Kingston Park", value: "Newcastle" },
  ],
},

{
  matchKey: "leicester-vs-northampton-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Welford Road, Leicester" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=dvWT9BcgXVQ",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Leicester Tigers" },
    { category: "Coach", player: "TBD", value: "Northampton Saints" },
    { category: "Venue", player: "Welford Road", value: "Leicester" },
    { category: "Note", player: "East Midlands Derby", value: "Leicester vs Northampton" },
  ],
},

{
  matchKey: "bristol-vs-exeter-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Ashton Gate, Bristol" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=VLcs8NlfBqk",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Bristol Bears" },
    { category: "Coach", player: "TBD", value: "Exeter Chiefs" },
    { category: "Venue", player: "Ashton Gate", value: "Bristol" },
  ],
},

{
  matchKey: "harlequins-vs-saracens-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Twickenham Stoop, London" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "https://www.youtube.com/watch?v=GlsDxVciEI4",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "TBD", value: "Harlequins" },
    { category: "Coach", player: "TBD", value: "Saracens" },
    { category: "Venue", player: "Twickenham Stoop", value: "London" },
    { category: "Note", player: "London Derby", value: "Harlequins vs Saracens" },
  ],
},

// ==================================================
// GALLAGHER PREMIERSHIP 2026/27 – ROUND 5
// ==================================================

{
  matchKey: "bristol-vs-leicester-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Ashton Gate, Bristol" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Pat Lam", value: "Bristol Bears" },
    { category: "Coach", player: "Michael Cheika", value: "Leicester Tigers" },
    { category: "Captain", player: "TBD", value: "Bristol Bears" },
    { category: "Captain", player: "TBD", value: "Leicester Tigers" },
    { category: "Venue", player: "Ashton Gate", value: "Bristol" },
  ],
},

{
  matchKey: "exeter-vs-harlequins-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Sandy Park, Exeter" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Rob Baxter", value: "Exeter Chiefs" },
    { category: "Coach", player: "Danny Wilson", value: "Harlequins" },
    { category: "Captain", player: "TBD", value: "Exeter Chiefs" },
    { category: "Captain", player: "TBD", value: "Harlequins" },
    { category: "Venue", player: "Sandy Park", value: "Exeter" },
  ],
},

{
  matchKey: "saracens-vs-newcastle-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — StoneX Stadium, London" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Mark McCall", value: "Saracens" },
    { category: "Coach", player: "TBD", value: "Newcastle" },
    { category: "Captain", player: "TBD", value: "Saracens" },
    { category: "Captain", player: "TBD", value: "Newcastle" },
    { category: "Venue", player: "StoneX Stadium", value: "London" },
  ],
},

{
  matchKey: "bath-vs-sale-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Recreation Ground, Bath" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Johann van Graan", value: "Bath" },
    { category: "Coach", player: "Alex Sanderson", value: "Sale Sharks" },
    { category: "Captain", player: "TBD", value: "Bath" },
    { category: "Captain", player: "TBD", value: "Sale Sharks" },
    { category: "Venue", player: "Recreation Ground", value: "Bath" },
  ],
},

{
  matchKey: "northampton-vs-gloucester-premiership",
  timeline: [
    { minute: "0'", label: "Kick-off — Franklin's Gardens, Northampton" },
    { minute: "40'", label: "Half Time" },
    { minute: "80'", label: "Full Time" },
  ],
  highlightsUrl: "",
  matchStats: {
    home: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
    away: { metresMade: 0, carries: 0, defendersBeaten: 0, cleanBreaks: 0, offloads: 0, tacklesMade: 0, tacklesMissed: 0, turnoversWon: 0, penaltiesConceded: 0 },
  },
  performances: [
    { category: "Coach", player: "Phil Dowson", value: "Northampton Saints" },
    { category: "Coach", player: "George Skivington", value: "Gloucester" },
    { category: "Captain", player: "TBD", value: "Northampton Saints" },
    { category: "Captain", player: "TBD", value: "Gloucester" },
    { category: "Venue", player: "Franklin's Gardens", value: "Northampton" },
  ],
},

];